import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { queryKeys } from "@/queryKeys";
import { brokerService } from "@/services/brokers";

interface BrokersQueryOptions {
  enabled?: boolean;
  /** Keep the last results on screen while a new search loads. */
  keepPrevious?: boolean;
}

export function useBrokersQuery(
  search: string,
  page: number,
  isSteddyUser?: boolean | null,
  { enabled = true, keepPrevious = false }: BrokersQueryOptions = {}
) {
  return useQuery({
    queryKey: queryKeys.brokers(search, page, isSteddyUser ?? null),
    queryFn: () =>
      brokerService.list({
        page,
        search,
        ...(typeof isSteddyUser === "boolean" ? { is_steddyuser: isSteddyUser } : {}),
      }),
    staleTime: 30_000,
    enabled,
    placeholderData: keepPrevious ? keepPreviousData : undefined,
  });
}
